import { render, staticRenderFns } from "./SBoxStemdoerEducation.vue?vue&type=template&id=2ae395e4&scoped=true"
import script from "./sBoxStemdoerEducation.ts?vue&type=script&lang=ts&external"
export * from "./sBoxStemdoerEducation.ts?vue&type=script&lang=ts&external"
import style0 from "./SBoxStemdoerEducation.vue?vue&type=style&index=0&id=2ae395e4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae395e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae395e4')) {
      api.createRecord('2ae395e4', component.options)
    } else {
      api.reload('2ae395e4', component.options)
    }
    module.hot.accept("./SBoxStemdoerEducation.vue?vue&type=template&id=2ae395e4&scoped=true", function () {
      api.rerender('2ae395e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-box-stemdoer-education/SBoxStemdoerEducation.vue"
export default component.exports